<button
    (click)="handleClick($event)"
    [attr.disabled]="isDisabled || loading ? 'disabled' : null"
    [attr.aria-busy]="loading ? 'true' : null"
    [class.ac-button-disabled]="isDisabled"
    [class.ac-button-loading]="loading"
    class="ac-button ac-button-color-{{ color }} ac-button-type-{{ type }}"
>
    <ng-content *ngIf="!loading; else loadingTemplate"></ng-content>

    <ng-template #loadingTemplate>
        <div class="ac-button-loader ac-button-color-{{ color }}">
            <div class="loader-container">
                <div class="snippet" data-title="dot-flashing">
                    <div class="stage">
                        <div class="dot-flashing"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</button>